/**
 * Inline line icons for markup built in TypeScript. The stroke follows
 * currentColor, so an icon takes the colour of the text beside it.
 * Static markup in taskpane.html inlines the same SVG shape directly.
 */
const icon = (paths: string, size: number): string =>
  `<svg class="icon" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" ` +
  `stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths}</svg>`;

export const chevronDownIcon = icon('<path d="m6 9 6 6 6-6"/>', 12);
export const chevronLeftIcon = icon('<path d="m15 18-6-6 6-6"/>', 12);
export const chevronRightIcon = icon('<path d="m9 18 6-6-6-6"/>', 12);
export const arrowRightIcon = icon('<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>', 11);
export const crosshairIcon = icon(
  '<circle cx="12" cy="12" r="7"/><path d="M12 2v4"/><path d="M12 18v4"/><path d="M2 12h4"/><path d="M18 12h4"/>',
  14
);
